import { render, staticRenderFns } from "./GroupSettingNav.vue?vue&type=template&id=6fb30452&"
import script from "./GroupSettingNav.vue?vue&type=script&lang=ts&"
export * from "./GroupSettingNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports